<template>
  <v-container py-0>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.type') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              notification.type
                ? $t(`fields.notifications.type.${notification.type}`)
                : ''
            }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.notifications.typeRemittent') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              notification.typeRemittent
                ? $t(
                    `fields.notifications.remittent.${notification.typeRemittent}`
                  )
                : ''
            }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.notifications.remittent') }}
          </v-flex>
          <v-flex xs12 md6>
            <template v-if="notification.typeRemittent == 'fbase'">
              FBASE.Tv
            </template>
            <template
              v-else-if="notification.remittent && notification.remittent.name"
            >
              <v-chip color="transparent" small>
                <v-avatar
                  v-if="notification.remittent.img"
                  size="32"
                  style="padding: 0"
                >
                  <img :src="notification.remittent.img" alt />
                </v-avatar>
                <span>{{ notification.remittent.name }}</span>
              </v-chip>
            </template>
            <template v-else> - </template>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.notifications.typeReceiver') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              notification.typeReceiver
                ? $t(
                    `fields.notifications.receiver.${notification.typeReceiver}`
                  )
                : ''
            }}
          </v-flex>
        </v-layout>
        <v-layout v-if="notification.sendType" row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.notifications.sendType') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              notification.sendType
                .map((type) => $t(`fields.notifications.sendTypes.${type}`))
                .join(',')
            }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.notifications.title') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ getName(notification.title) }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.notifications.text') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ getName(notification.text) }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.notifications.sendDate') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(notification.sendDate, true) }}
          </v-flex>
        </v-layout>

        <!-- <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">{{$t('fields.global.updatedAt')}}</v-flex>
          <v-flex xs12 md6>{{formatDate(notification.updatedAt)}}</v-flex>
        </v-layout>-->
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdBy') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              notification.createdBy
                ? notification.createdBy.name +
                  ' ' +
                  notification.createdBy.lastname1
                : '-'
            }}
          </v-flex>
        </v-layout>
        <v-layout
          v-if="notification.sendType && notification.sendType.includes('push')"
          row
          wrap
          my-3
          align-center
        >
          <v-flex xs12 md4 justify-center class="body-2">
            {{
              `${$t('titles.notifications.progress')} (${$t(
                'fields.notifications.sendTypes.push'
              )})`
            }}
          </v-flex>
          <v-flex xs12 md6>
            <v-progress-linear
              :value="progressPush"
              color="primary"
              height="20"
            >
              <strong class="d-flex align-center justify-center"
                >{{ Math.ceil(progressPush) }}%</strong
              >
            </v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="
            notification.sendType && notification.sendType.includes('email')
          "
          row
          wrap
          my-3
          align-center
        >
          <v-flex xs12 md4 justify-center class="body-2">
            {{
              `${$t('titles.notifications.progress')} (${$t(
                'fields.notifications.sendTypes.email'
              )})`
            }}
          </v-flex>
          <v-flex xs12 md6>
            <v-progress-linear
              :value="progressEmail"
              color="primary"
              height="20"
              class="d-flex justify-content-center align-items-center"
            >
              <strong class="d-flex align-center justify-center"
                >{{ Math.ceil(progressEmail) }}%</strong
              >
            </v-progress-linear>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { formatDate } from '@/helpers'

export default {
  name: 'TabView',
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
  },
  mounted() {},
  computed: {
    ...mapState({
      notification: (state) => state.notifications.selected,
    }),
    imageUrl() {
      if (this.entity.logo && this.entity.logo.includes('http')) {
        return this.entity.logo
      } else return this.defaultValues.imageUrl + this.entity.logo
    },
    progressPush() {
      const job =
        this.notification.jobs &&
        this.notification.jobs.find((job) => job.queue.includes('push'))
      return job ? job.progress : 0
    },
    progressEmail() {
      const job =
        this.notification.jobs &&
        this.notification.jobs.find((job) => job.queue.includes('email'))
      return job ? job.progress : 0
    },
  },
  methods: {
    ...mapActions({}),
    formatDate(date) {
      return formatDate(date)
    },
    cancel() {
      this.tab = 0
      this.reset()
      this.resetTeamState()
      this.$emit('close')
    },
  },
}
</script>
